import * as base from './base';
import { log } from './log';
// 显示“浏览器打开”提示
const showWxIndicator = () => {
    // 插入样式
    const style = document.createElement('style');
    style.type = 'text/css';
    style.append(`
  @keyframes wxIndicatorFadeIn {
    from {background-color: rgba(0,0,0,.55);}
    to {background-color: rgba(0,0,0,.85);}
  }
  .wx-indicator {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.85);
    z-index: 1001;
    animation: wxIndicatorFadeIn 0.25s linear both;
  }
  .wx-note {
    margin: 0 auto;
    width: calc(100vw - 20px);
    height: 120px;
    border-radius: 0 0 8px 8px;
    background: #f9f9f9 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP4AAACgCAMAAAAbzCHkAAAAP1BMVEUAAABNTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU0SjmMjAAAAFHRSTlMABifv9a0RHEtpyYN41rmhW5E14O1mmvUAAAOFSURBVHja7Z3JcuMwDESb+yaJktj//60j21nkSk1qJqckrXdx0TdIINgEQAq/g2ggzEZfIEvmwQRVFt7I0CTxToUmGyn8+qOjTxvJBYo0siMOkjv0SJ4+AVn09Qey4KBLzv6V7LhhqmDwT46LwZ04k2Laz1TWCLzZ7yKU2B7W27LuN/srO4SYGMw5AJigFP1WttfHwA13tiHj/uu8v8ve6fXPRWTrn9Y3Q/sp5lu9ne9yVjxGTvvWZ70v4v5vODJBFkN66GLJGbpkzb3uK4VaYveDAmhCWvfi4h1Tu57QfWfXXvfEA/8ml+N7oipmuN8wnpRJ8XxkJwd0KWSALl078g3N0u4LifRq2a0T+yy92QeSxYUmaRWWPMBENuhSyRWyREoL/lWwoedEUO5lvm92hVf9rJ3m69LLnrjvr9q+36TjPpAm4a4OcbRffdYubgVygyyW0ov+Jt3QZJx0ZbNIl/bMkK5traQTLu7M0lvdTHrhFKcNypLnwAoLfmG/P8i+CT8Aox32C9UO656JTjrF18ihK/iSl65pB+mibha9ouWBGdIZvia96MEuylmOA+EEXxbe5gHWO+EV31Ry1tV7jfS6S/4ufSNnnKWrWp10uoG/SN7H98rulbV+nKXXPDR64V4GIOtOfGHTD3YvLHeQHDnLpjjiTDrZsGcW0uvO/U7ltP4mvc1rVNa6E6VvpiikysWzz6hdu/uRIl3PmKS7VhvJKuv5G8lFVeibTuGYHxeSQdX6VCl8SGsfVG5bzF54yTNAcar7+xg24YZtq/dpoROrFw56sZOUnfb7TLKqlrAnT3ITVXqpKjs+4tB1fGuBzKbp+Kb5agDRV5+HcCEjBR5UzQpmbJ6k05S5pjgedNFZv/CgajbpRqCQQ9Pvc62AqZoHkddZt0HVlJkHXnKpT83xwG+K4T4G3nCKcz4ZmEFyFD3jzbowA42LXsgzuXuSQfFDCnENngeSB3HMwgez2sWaae0JmO+2NymnN3vpg+QKbKzTd7bdBueC/WTwn6SyVc8H/Rh+b5+3jgfOfjL4N4zNZZuAzBf8Mn3/zWzgnfDp4BkTo3n5tRZAaX2pgzdmwPJghPL9Tb/heMd/Ongm8EQCPN8xQJ9+0Cn7L5i/8IQFBu+M2qf1p+Xqv+D8m+MD58ZsgamVdU8/zfB/CX2//xSNDd4H+9fBL7f+4uLi4uLi4kKDP86WOhW/KDIMAAAAAElFTkSuQmCC) 100% 4px no-repeat;
    background-size: 127px auto;
  }
  .wx-arrows {
    float: right;
    margin: 39px 0 0 0;
    width: 225px;
    line-height: 20px;
    color: #222;
  }

  .wx-arrows h3 {
    margin: 0 0 6px;
  }`);
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(style);
    // 插入dom
    const h3 = document.createElement('h3');
    h3.append('链接打不开？');
    const div = document.createElement('div');
    div.append('请点击右上角', document.createElement('br'), '选择在 “浏览器” 中打开');
    const arrows = document.createElement('div');
    arrows.classList.add('wx-arrows');
    arrows.append(h3, div);
    const note = document.createElement('div');
    note.classList.add('wx-note');
    note.append(arrows);
    const container = document.createElement('div');
    container.classList.add('wx-indicator');
    container.append(note);
    document.body.appendChild(container);
    container.addEventListener('click', () => {
        var _a, _b;
        (_a = style.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(style);
        (_b = container.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(container);
    });
    log('微信中显示”浏览器打开“提示');
};
// 唤起小米穿戴APP
export const toApp = (obj) => {
    // 在米家app内或者非android/ios设备，不会执行唤起动作
    if (base.isInWearable || (!base.isAndroid && !base.isIos)) {
        return;
    }
    if (base.isWeibo || (base.isAndroid && base.isWx)) {
        showWxIndicator();
        return;
    }
    const params = new URLSearchParams();
    if (typeof obj === 'object') {
        for (const key in obj) {
            params.append(key, obj[key]);
        }
    }
    else if (typeof obj === 'string') {
        const url = obj;
        params.append('url', url);
    }
    params.append('jssdkTime', String(Date.now()));
    log('唤起小米穿戴APP');
    // android 与 ios 走不同的路径
    if (base.isAndroid) {
        const hasPageType = typeof obj === 'object' && obj.pageType;
        // intent 跳转到native界面；web.xiaomi.com 跳转到webview
        window.location.href = `wearable://${hasPageType ? 'intent' : 'web.xiaomi.com/toApp'}?${params.toString()}`;
        const timer = setTimeout(() => {
            // app直接的下载链接：https://hlth.io.mi.com/download
            window.location.href =
                'https://g.watch.iot.mi.com/libai/download-miwear.html';
        }, 2500);
        // 实际上在浏览器中无法真正判断是否安装了客户端
        // 如果app被唤起了，那么页面应该被压入后台
        // 通过 visibilitychange 事件间接地判断客户端是否被唤起
        document.addEventListener('visibilitychange', function () {
            // https://developer.mozilla.org/zh-CN/docs/Web/API/Document/visibilitychange_event
            if (document.visibilityState === 'hidden') {
                clearTimeout(timer);
            }
        });
    }
    else {
        window.location.href =
            'https://g.watch.iot.mi.com/libai/download-miwear.html?' +
                params.toString();
    }
};
// 显示”打开App查看“按钮
// 若app已安装，则唤起app，浏览器停留在原页面
// 若app未安装，或者用户取消唤起动作、用户长时间等待，则跳转到下载页
// 微信中，弹出”用浏览器打开“提示
export const showAppEntry = ({ url }) => {
    // 如果在米家app中，则不会显示该按钮
    if (base.isInWearable) {
        return;
    }
    // 插入样式
    const style = document.createElement('style');
    style.type = 'text/css';
    style.append(`
  .open-mihome {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    width: 100%;
    padding: 10px 0 14px;
    position: fixed;
    bottom: 0;
    z-index: 1000;
    left: 0;
  }
  .open-mihome > div {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(90deg,#ff5a4c,#ff1d12);
    border-radius: 100px;
    width: 220px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }
  .open-mihome .mihome-icon {
    margin-right: 5px;
    display: block;
    width: 21px;
    height: 23px;
  }`);
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(style);
    // 插入dom
    const img = document.createElement('img');
    img.classList.add('mihome-icon');
    img.src =
        'http://cdn.cnbj0.fds.api.mi-img.com/miio.files/commonfile_png_9140f2efbe964f878cf977917ccf903a.png';
    const btn = document.createElement('div');
    btn.append(img, '打开App查看');
    btn.addEventListener('click', () => {
        toApp(url);
    });
    const container = document.createElement('div');
    container.classList.add('open-mihome');
    container.append(btn);
    document.body.appendChild(container);
    log('显示唤起米家APP按钮');
};
//# sourceMappingURL=data:application/json;base64,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